export default __webpack_public_path__ + "static/media/searchIcon.130d2cd2.svg";